<!DOCTYPE html>
@if (inboxData$ | async; as inboxData) {
  <div>
    <div class="close" (click)="closeDialog()">
      <img src="assets/images/cross-img.png" />
    </div>
    <div class="gradient-bg"></div>
    <ion-grid class="ion-no-padding store-wrapper">
      <ion-row>
        <div class="store-card">
          <img class="hero-img" src="{{inboxData?.logo}}" alt="hero-img" />
        </div>
      </ion-row>
      @if (alone$ | async; as alone) {
        <ion-row>
          <div class="title-wrapper" [innerHTML]="contentTitle | safeHtml">
          </div>
          <!-- progress par section start -->
          <div class="card-wrapper-progress">
            <div class="card">
              <div class="row-bar">
                <div class="title">Together</div>
                <div class="progress">
                  <div class="progress-bar">
                    <div class="progress-bar">
                  <div class="fill" [ngStyle]="{
                  'width.%': getProgressBar(false) <= 100 ? getProgressBar(false) : 0,
                  background: 'linear-gradient(180deg, #17D9D2 0%, #1FD583 100%)'
                }"></div>
                    </div>
                  </div>
                </div>
                <div class="nu">{{messageData?.template_data?.we_won}}</div>
              </div>
              <div class="row-bar">
                <div class="title">Alone</div>
                <div class="progress">
                  <div class="progress-bar">
                    <div class="progress-bar">
                  <div class="fill" [ngStyle]="{
                  'width.%': getProgressBar(true) <= 100 ? getProgressBar(true) : 0,
                  background: 'linear-gradient(180deg, #17D9D2 0%, #1FD583 100%)'
                }"></div>
                    </div>
                  </div>
                </div>
                <div class="nu">{{messageData?.template_data?.alone_won}}</div>
              </div>
            </div>
          </div>
          <!-- progress par section end -->
          <div class="desc-wrapper" [innerHTML]="htmlContent | safeHtml">
          </div>
        </ion-row>
      }
      <ion-row>
        <div class="btn-wrapper">
          <ion-button (click)="close()" expand="block" class="capsule-btn common-margin">
            Dismiss
          </ion-button>
        </div>
      </ion-row>
    </ion-grid>
  </div>
}
